import { render, staticRenderFns } from "./MconEditAbout.vue?vue&type=template&id=a0e8e4aa&scoped=true&"
import script from "./MconEditAbout.vue?vue&type=script&lang=js&"
export * from "./MconEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e8e4aa",
  null
  
)

export default component.exports